import { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { ReviewRatings } from '../ReviewRatings'
import { useAppIntl } from 'src/i18n'

interface RatingAttribute {
  name: string
}

interface Rating {
  attributes?: {
    show?: boolean
    score?: number
    ratingAttribute?: {
      data?: {
        attributes?: RatingAttribute
      }
    }
  }
}

interface ReviewData {
  title?: string
  ratings?: {
    data?: Rating[]
  }
}

interface ReviewComponentProps {
  data: ReviewData
}

function ReviewComponent({ data }: ReviewComponentProps): JSX.Element {
  const intl = useAppIntl()
  const filteredRatings = data.ratings?.data?.filter(
    rating => rating.attributes?.show === true
  )

  return (
    <div className={styles.main}>
      <div className={styles.mainUpper}>
        <h2 className={styles.reviewTitle}>
          {data?.title} {intl.t('review.item.score')}
        </h2>
      </div>
      <div className={styles.mainLower}>
        {filteredRatings?.map((rating, ratingIndex) => (
          <ReviewRatings key={ratingIndex} ratingData={rating} />
        ))}
      </div>
    </div>
  )
}

export default ReviewComponent
